var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:[("cell-value-" + _vm.col)]},[_c('router-link',{attrs:{"to":{ name: _vm.refEditName, params: { id: _vm.entry[_vm.col] } }}},[_vm._v("\n    "+_vm._s(_vm.display ? _vm.display : _vm.entry[_vm.col])+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }